module.exports = __webpack_public_path__ + "static/img/evidence.c3cd0ad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/fifth/hk/evidence.png
// module id = FiDC
// module chunks = 1 3